import styled from '@emotion/styled';
import { FileReference } from '@kaizenplatform/belfast-entity';
import { ClassAttributes, createElement } from 'react';

import { ProjectChangeType } from '../../../service/persistent/ProjectChangeWebApi';
import { ProjectType } from '../../../service/persistent/ProjectWebApi';
import _Breadcrumbs from '../../connected/Breadcrumbs';
import { SPACING_UNIT } from '../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../styleUtility/gridLayout';
import _CreativeBrief from './CreativeBrief';
import _OrganizationName from './OrganizationName';
import _ProjectTitle from './ProjectTitle';

type Props = ClassAttributes<HTMLElement> & {
  project: ProjectType | null;
  projectChange: ProjectChangeType;
  latestBriefFiles: Map<string, FileReference[]>;
  beforeBriefFiles: Map<string, FileReference[]>;
  assetFiles: ReadonlyArray<FileReference>;
  briefFiles: Map<string, FileReference[]>;
  projectLoading: boolean;
  className?: string;
};

const ProjectDiffPage = ({
  project,
  projectChange,
  latestBriefFiles,
  beforeBriefFiles,
  assetFiles,
  briefFiles,
  projectLoading,
  className,
}: Props) => (
  <Root className={className}>
    <Breadcrumbs />

    <ProjectTitle project={project} loading={projectLoading} />
    <OrganizationName organization={project?.organization} loading={projectLoading} />

    <CreativeBrief
      project={project}
      projectChange={projectChange}
      latestBriefFiles={latestBriefFiles}
      beforeBriefFiles={beforeBriefFiles}
      assetFiles={assetFiles}
      briefFiles={briefFiles}
      loading={projectLoading}
    />
  </Root>
);

const Root = styled('div')({
  ...gridLayoutContainer({
    columns: ['100%'],
    rows: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
    areas: [
      ['breadcrumbs'],
      ['projectTitle'],
      ['organizationName'],
      ['creatives'],
      ['creativeBrief'],
      ['relatedProjects'],
    ],
  }),
  margin: `0 ${SPACING_UNIT}px`,
  padding: `${SPACING_UNIT * 5}px calc((100% - 960px) / 2) ${SPACING_UNIT * 10}px`,
});

const Breadcrumbs = styled(_Breadcrumbs)({ ...gridLayoutItem('breadcrumbs'), marginBottom: SPACING_UNIT * 5 });

const ProjectTitle = styled(_ProjectTitle)(gridLayoutItem('projectTitle'));

const OrganizationName = styled(_OrganizationName)({
  ...gridLayoutItem('organizationName'),
  marginBottom: SPACING_UNIT * 5,
});

const CreativeBrief = styled(_CreativeBrief)({ ...gridLayoutItem('creativeBrief'), marginBottom: SPACING_UNIT * 5 });

export default ProjectDiffPage;
